import React from "react";
import Navbar from "../Navbar/Navbar";
//Stylesheet
import './HeaderCss/header.css';

const Header = () => {
    return (
        <header>
            <Navbar />
        </header>
    )
}

export default Header;